export const BrandingBg = ({ bgOpacity = undefined, children }) => {
  return (
    <div
      className="flex w-full min-h-full items-stretch"
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + "/images/dissesto-idrogeologico-italia1.jpg"
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className={
          `w-full py-6 ` +
          (bgOpacity === "60"
            ? "bg-black bg-opacity-60"
            : bgOpacity === "40"
            ? "bg-black bg-opacity-40"
            : "")
        }
      >
        {children}
      </div>
    </div>
  );
};
